import { Component } from "react";

import CivDataHelper from "./CivDataHelper";

class MatchInfo extends Component {
  static getColor = (colorId) => {
    var colorHex = "#0072ff";
    const colors = {
      1: "#0072ff",
      2: "#e91e1e",
      3: "#00FF0A",
      4: "#faff00",
      5: "#00bcd4",
      6: "#ec5ee2",
      7: "#d0d0d0",
      8: "#ff9800",
    };

    if (colorId > 0 && colorId <= 9) {
      return colors[colorId];
    }
    return colorHex;
  };

  static getPlayerColors = (profileIdentifier, players) => {
    const profileId =
      typeof profileIdentifier === "string"
        ? profileIdentifier
        : profileIdentifier.toString();
    let playerFiltered = players.filter((player) => {
      if (player.profile_id.toString() === profileId) {
        return true;
      }
      return false;
    });

    return MatchInfo.getColor(playerFiltered[0].color);
  };

  static getPlayerCiv = (profileIdentifier, players) => {
    const profileId =
      typeof profileIdentifier === "string"
        ? profileIdentifier
        : profileIdentifier.toString();
    let playerFiltered = players.filter((player) => {
      if (player.profile_id.toString() === profileId) {
        return true;
      }
      return false;
    });

    return CivDataHelper.getCivName(playerFiltered[0].civ);
  };

  static getPlayerTeam = (profileIdentifier, players) => {
    const profileId =
      typeof profileIdentifier === "string"
        ? profileIdentifier
        : profileIdentifier.toString();
    let playerFiltered = players.filter((player) => {
      if (player.profile_id.toString() === profileId) {
        return true;
      }
      return false;
    });

    return playerFiltered[0].team;
  };

  static getPlayerByTeam = (team, players) => {
    let playerFiltered = players.filter((player) => {
      if (player.team === team) {
        return true;
      }
      return false;
    });

    let playersBeautified = playerFiltered.map((player) => {
      return {
        profileId: player.profile_id,
        username: player.name,
        color: MatchInfo.getColor(player.color),
        civilization: CivDataHelper.getCivName(player.civ),
        eloRM: 0,
        eloEW: 0,
      };
    });

    return playersBeautified;
  };

  static guetOtherTeam = (team, players) => {
    let playerFiltered = players.filter((player) => {
      if (player.team !== team) {
        return true;
      }
      return false;
    });

    return playerFiltered[0].team;
  };
}

export default MatchInfo;
